import { useLanguage } from '../utils/i18n';

export default function LanguageToggle() {
    const { lang, changeLanguage } = useLanguage();

    const handleToggle = () => {
        const order = ['en', 'es', 'fr'];
        const nextIndex = (order.indexOf(lang) + 1) % order.length;
        changeLanguage(order[nextIndex]);
    };

    const labels = {
        en: 'EN',
        es: 'ES',
        fr: 'FR'
    };

    const tooltips = {
        en: 'Switch language',
        es: 'Cambiar idioma',
        fr: 'Changer de langue'
    };

    return (
        <button
            onClick={handleToggle}
            className="btn btn-outline btn-sm"
            style={{ padding: '6px 10px', fontSize: 12, fontWeight: 700, background: 'var(--surface)', border: '1px solid var(--border-bright)', color: 'var(--text)' }}
            title={tooltips[lang]}
        >
            🌐 {labels[lang]}
        </button>
    );
}
